<dx-toolbar height="54" style="padding-left: 8px; padding-right: 8px;">
    <dxi-item location="after">
        <dx-button text="Refresh" (onClick)="refreshed.emit()"></dx-button>
    </dxi-item>
    <dxi-item location="after">
        <dx-button text="New Standing Order" (onClick)="newStandingOrder()"></dx-button>
    </dxi-item>
</dx-toolbar>
<dx-data-grid id="gridContainer"
    [dataSource]="patientsStore"
    [masterDetail]="{ enabled: true, template: 'detail' }"
    height="60vh"
    keyExpr="Id"
    [showBorders]="true"
    [wordWrapEnabled]="true"
    [columnHidingEnabled]="isPhoneOrTablet"
    (onRowExpanding)="onRowExpanding($event)">
    <dxo-pager
        [visible]="true"
        [allowedPageSizes]="[10, 20, 50, 100]"
        [showInfo]="true"
        [showNavigationButtons]="true"
        [showPageSizeSelector]="true"
    ></dxo-pager>
    <dxo-filter-row [showOperationChooser]="true" [visible]="true"></dxo-filter-row>
    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxi-column caption="Last Name" dataField="lastName" [hidingPriority]="isPhoneOrTablet ? 4 : null"></dxi-column>
    <dxi-column caption="First Name" dataField="firstName" [hidingPriority]="isPhoneOrTablet ? 3 : null"></dxi-column>
    <dxi-column caption="DOB" dataField="birthDate" dataType="date" [hidingPriority]="isPhoneOrTablet ? 2 : null"></dxi-column>
    <dxi-column caption="SSN" dataField="ssn" [hidingPriority]="isPhoneOrTablet ? 1 : null"></dxi-column>
    <dxi-column caption="Gender" dataField="gender" [hidingPriority]="isPhoneOrTablet ? 0 : null"></dxi-column>

    <div *dxTemplate="let patient of 'detail'">
        <div class="dx-card">
            <dx-toolbar height="54" style="padding-left: 16px; padding-right: 16px;">
                <dxi-item location="before">
                    <h5 style="margin-bottom: 0; margin-top: 0">{{ patient.data.lastName }}, {{ patient.data.firstName }}</h5>
                </dxi-item>
                <dxi-item location="after" *ngIf="!isPhoneOrTablet">
                    <dx-button text="New Standing Order" (click)="newStandingOrder(patient.data.id)"></dx-button>
                </dxi-item>
                <dxi-item location="after" *ngIf="!isPhoneOrTablet">
                    <dx-button text="Edit Patient" (click)="editPatient(patient.data)"></dx-button>
                </dxi-item>
                <dxi-item location="after" *ngIf="!isPhoneOrTablet">
                    <dx-button text="Edit Standing Order" [disabled]="selectedRowKeys.length !== 1" (click)="editStandingOrder(selectedRowKeys[0])"></dx-button>
                </dxi-item>
                <dxi-item location="after" *ngIf="!isPhoneOrTablet">
                    <dx-button text="Cancel Standing Order" [disabled]="selectedRowKeys.length === 0" (click)="cancelStandingOrder(selectedRowKeys)"></dx-button>
                </dxi-item>
            </dx-toolbar>
            <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between" style="padding-left: 16px; padding-right: 16px; margin-bottom: 5px">
                <address class="details">
                    <span class="strong">DOB:</span> {{ patient.data.birthDate !== null ? dateHelper.dateWithFormatWithoutUtc(patient.data.birthDate, "MM/DD/YYYY hh:mm a") : ''}} <br/>
                    <span class="strong">SSN:</span> {{ patient.data.ssn }}
                </address>
                <div fxLayoutAlign="end end" fxLayoutAlign.xs="start end">
                    <span class="strong">Showing only active standing orders</span>
                </div>
            </div>
            <dx-data-grid
                [dataSource]="patient.data.standingOrders"
                [showBorders]="true"
                style="padding-left: 16px; padding-right: 16px"
                [keyExpr]="'id'"
                [(selectedRowKeys)]="selectedRowKeys"
                [columnAutoWidth]="true"
                [wordWrapEnabled]="true"
                [columnHidingEnabled]="isPhoneOrTablet">
                <dxo-filter-panel [visible]="true"></dxo-filter-panel>
                <dxo-pager
                    [visible]="true"
                    [allowedPageSizes]="[10, 20, 50, 100]"
                    [showInfo]="true"
                    [showNavigationButtons]="true"
                    [showPageSizeSelector]="true"
                ></dxo-pager>
                <dxo-filter-row [showOperationChooser]="true" [visible]="true"></dxo-filter-row>
                <dxo-selection mode="multiple" showCheckBoxesMode="always" selectAllMode="page"></dxo-selection>
                <dxi-column caption="Test" dataField="test" [hidingPriority]="isPhoneOrTablet ? 5 : null"></dxi-column>
                <dxi-column caption="Start" dataField="start" dataType="date" [hidingPriority]="isPhoneOrTablet ? 3 : null"></dxi-column>
                <dxi-column caption="Frequency" dataField="frequency" [hidingPriority]="isPhoneOrTablet ? 4 : null"></dxi-column>
                <dxi-column caption="End" dataField="end" dataType="date" [hidingPriority]="isPhoneOrTablet ? 2 : null"></dxi-column>
                <dxi-column caption="Client" dataField="client" [hidingPriority]="isPhoneOrTablet ? 1 : null"></dxi-column>
                <dxi-column caption="Physician" dataField="physicianFullName" [hidingPriority]="isPhoneOrTablet ? 0 : null"></dxi-column>
            </dx-data-grid>
        </div>

        <dx-speed-dial-action
            icon="add"
            label="New Standing Order"
            [index]="1"
            [visible]="isPhoneOrTablet"
            (onClick)="newStandingOrder(patient.data.id)"
            (onContentReady)="onButtonReady($event)">
        </dx-speed-dial-action>
        <dx-speed-dial-action
            icon="edit"
            label="Edit Patient"
            [index]="2"
            [visible]="isPhoneOrTablet"
            (onClick)="editPatient(patient.data)"
            (onContentReady)="onButtonReady($event)">
        </dx-speed-dial-action>
        <dx-speed-dial-action
            icon="fas fa-edit"
            label="Edit Standing Order"
            [visible]="isPhoneOrTablet && selectedRowKeys.length === 1"
            [index]="3"
            (onClick)="editStandingOrder(selectedRowKeys[0])"
            (onContentReady)="onButtonReady($event)">
        </dx-speed-dial-action>
        <dx-speed-dial-action
            icon="clear"
            label="Cancel Standing Order"
            [visible]="isPhoneOrTablet && selectedRowKeys.length !== 0"
            (onClick)="cancelStandingOrder(selectedRowKeys)"
            [index]="4"
            (onContentReady)="onButtonReady($event)">
        </dx-speed-dial-action>
    </div>
</dx-data-grid>
<dx-load-panel
    shadingColor="rgba(0,0,0,0.4)"
    [visible]="isLoading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false">
</dx-load-panel>
